import { render, staticRenderFns } from "./TaxTypes.vue?vue&type=template&id=38c0b938&"
import script from "./TaxTypes.vue?vue&type=script&lang=js&"
export * from "./TaxTypes.vue?vue&type=script&lang=js&"
import style0 from "./TaxTypes.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports